export default "__VITE_ASSET__DQ71SMPL__"